<template>
  <footer class="footer">
    <b-container class="pl-0 pr-0">
      <b-row class="footer__border align-items-top pt-3">
        <b-col order="2" order-md="1" cols="6" md="2" class="p-0">
          <b-list-group>
            <b-list-group-item>Group 1</b-list-group-item>
            <b-list-group-item :to="{ name: 'home' }">Home</b-list-group-item>
            <b-list-group-item :to="{ name: 'faq' }">FAQ</b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col order="3" order-md="2" cols="6" md="4" class="p-0">
          <b-list-group-item>Group 2</b-list-group-item>
          <b-list-group-item :to="{ name: 'privacy-policy' }"
            >Privacy Policy</b-list-group-item
          >
          <b-list-group-item :to="{ name: 'terms-and-conditions' }"
            >Terms & Conditions</b-list-group-item
          >
        </b-col>

        <b-col order="1" order-md="3" cols="12" md="6" class="p-0">
          <b-list-group-item :to="{ name: 'home' }">
            <b-img
              class="footer__logo pb-1"
              v-bind="avatarProps"
              rounded
              alt="Logo"
              :src="require('@/assets/images/logo-title-w.svg')"
            ></b-img>
          </b-list-group-item>
          <b-list-group-item>
            <p>
              Ullamcorper. Praesent luctus lacus non lorem elementum, eu
              tristique sapien suscipit. Sed bibendum, nec viverra malesuada,
              erat nisi sodales purus eget.
            </p>
          </b-list-group-item>
        </b-col>
      </b-row>
      <div class="footer__copyright text-center">
        © Ullamcorper. Praesent luctus
      </div>
    </b-container>
  </footer>
</template>
<script>
/**
 * ==================================================================================
 * Footer section
 * ==================================================================================
 **/

export default {
  data() {
    return {
      avatarProps: {
        width: 150
      }
    }
  },
  methods: {
    onResize() {}
  }
}
</script>
<style lang="scss" scoped>
.footer {
  background: black 0% 0% no-repeat padding-box;
  padding-top: 65px;
  padding-bottom: 17.5px;
  background: var(--brand-black);

  &__border {
    max-width: 1120px;
    margin: 0 auto;
  }

  &__copyright {
    font-size: 0.9rem;
    margin-top: 100px;
    color: #fff;
  }

  &__logo {
    margin-bottom: 10px;
  }

  p {
    font-size: 0.95rem;
    line-height: 1rem;
  }

  .list-group-item {
    padding: 0 1.25rem 0.25rem 1.25rem;
    border: none;
    background: none;
    color: white;
  }
}

@media (max-width: 768px) {
  .footer {
    padding-top: 25px;

    p {
      font-size: 1rem;
      line-height: 1.5rem;
    }

    .list-group-item {
      padding-left: 0;
      padding-bottom: 0;
    }

    &__copyright {
      margin-top: 25px;
    }
  }
}
</style>
